import { OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Paths, createPath } from '../../app/router/app.router';

export function createOrderDetailsPageUrl(order: OrderDto, currentProjectShortcodeOrID: string): string | undefined {
  // Use the order retailer(project) information first, then fallback to the current project
  const projectShortcodeOrID = order.retailer?.shortcode ?? order.retailer.id ?? currentProjectShortcodeOrID;
  return createPath(Paths.order, { projectID: projectShortcodeOrID, orderID: order.id });
}
